import {
  buildProductCatApiParams,
  CAT_FILTER_ALL_FLAG,
  hasActiveCatScopeFilter,
  normalizeCatFilterValues,
  productMatchesCatFilter,
  PRODUCT_CAT_FILTER_FIELDS,
  type CatFilterAllFlag,
  type ProductCatApiParams,
  type ProductCatFilterField,
} from '@/utils/productCatFilters';

export type SupplyCatFilterAllFlag = CatFilterAllFlag;

export type SupplyCatActiveFilters = Partial<
  Record<ProductCatFilterField, string | string[]> &
  Record<SupplyCatFilterAllFlag, boolean>
>;

export const SUPPLY_CAT_FILTER_ALL_FLAGS = PRODUCT_CAT_FILTER_FIELDS.map(
  (field) => CAT_FILTER_ALL_FLAG[field],
);

export const SUPPLY_CAT_FILTER_ALL_FLAG = CAT_FILTER_ALL_FLAG;

export const normalizeSupplyCatValues = normalizeCatFilterValues;

export function supplyCatFilterEffectDeps(activeFilters: SupplyCatActiveFilters): unknown[] {
  return PRODUCT_CAT_FILTER_FIELDS.flatMap((field) => [
    activeFilters[field],
    activeFilters[SUPPLY_CAT_FILTER_ALL_FLAG[field]],
  ]);
}

export function hasSupplyCatScopeFilter(filters: SupplyCatActiveFilters): boolean {
  return hasActiveCatScopeFilter(filters, filters);
}

export function productMatchesSupplyCatFilter(
  product: Partial<Record<ProductCatFilterField, string | null | undefined>>,
  field: ProductCatFilterField,
  filters: SupplyCatActiveFilters,
): boolean {
  return productMatchesCatFilter(product, field, {
    valuesByField: filters,
    allFlags: filters,
  });
}

export function buildSupplyCatApiParams(
  filters: SupplyCatActiveFilters,
  visibleFields: ProductCatFilterField[],
): ProductCatApiParams {
  return buildProductCatApiParams(
    filters,
    visibleFields,
    (field) => Boolean(filters[SUPPLY_CAT_FILTER_ALL_FLAG[field]]),
  );
}

export function buildSupplyCatFilterBarOptions(
  filterData: Partial<Record<ProductCatFilterField, Array<{ value: string; label: string }>>>,
  visibleFields: ProductCatFilterField[],
  labelForField: (field: ProductCatFilterField) => string,
) {
  return visibleFields.map((field) => ({
    id: field,
    name: labelForField(field),
    options: (filterData[field] ?? []).map((option) => ({
      value: String(option.value),
      label: option.label,
    })),
    multiple: true,
  }));
}

